import React, { ReactNode } from "react";
import { Box } from "@chakra-ui/react";

interface IAppLayoutProps {
  children: ReactNode;
}

function AppLayout(props: IAppLayoutProps): React.JSX.Element {
  return (
    <Box minHeight="100vh" display="flex" flexDirection="column">
      <Box flex={1}>{props.children}</Box>
    </Box>
  );
}

export default AppLayout;